import React, { useState } from "react";
import { Modal, message, Upload, Button, Typography, Row, notification } from "antd";
import { FileExcelOutlined, WarningOutlined } from "@ant-design/icons";
import { BandejaAprobacionAdministracionPersonalService } from "services/contratos/BandejaAprobacionAdministracionPersonalService";
import { FormatoCarga } from "enums/FormatoCarga";

const EXCEL_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const ModalRenovarMasivamente = ({ visible, setVisible }) => {
    const { Text } = Typography;
    const [archivo, setArchivo] = useState([]);
    const [loading, setLoading] = useState(false);

    const onClickBtnRenovar = async () => {
        if (!archivo.name) {
            message.error("No ha seleccionado el archivo Excel");
            return;
        }
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("file", archivo);

            const response = await BandejaAprobacionAdministracionPersonalService.renovarMasivamente(formData);
            const contentType = response.headers["content-type"] || "";

            if (contentType.includes(EXCEL_CONTENT_TYPE) || contentType.includes("spreadsheetml")) {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: EXCEL_CONTENT_TYPE }));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "errores_renovacion_masiva.xlsx");
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);

                notification.warning({
                    message: "Proceso completado con errores",
                    description: "Algunos contratos no pudieron procesarse. Se descargó un Excel con el detalle de los errores.",
                    icon: <WarningOutlined style={{ color: "#faad14" }} />,
                    duration: 8,
                });
            } else {
                message.success("Todos los contratos se renovaron correctamente.");
            }

            setVisible(false);
        } catch (error) {
            notification.error({
                message: "Error",
                description: "Ocurrió un error al procesar el archivo. Intente nuevamente.",
            });
        } finally {
            setLoading(false);
        }
    };

    const uploadProps = {
        onRemove: () => setArchivo([]),
        beforeUpload: (file) => {
            if (!FormatoCarga.EXCEL.extension.includes(file.type)) {
                message.error(`${file.name} no es un archivo Excel`);
            } else {
                setArchivo(file);
            }
            return false;
        },
        archivo,
    };

    const limpiar = () => setArchivo([]);

    return (
        <Modal
            title="Renovar Masivamente Contratos"
            open={visible}
            onOk={onClickBtnRenovar}
            onCancel={() => setVisible(false)}
            okText="Renovar"
            okButtonProps={{ loading }}
            afterClose={limpiar}
            destroyOnClose
        >
            <div>
                <Row style={{ marginBottom: 12 }}>
                    <Text type="secondary">
                        Cargue un archivo Excel con las columnas <strong>DNI_COLABORADOR</strong> y{" "}
                        <strong>FECHA_FIN</strong> (formato dd/MM/yyyy). La fecha de inicio se
                        calculará automáticamente como el día siguiente al vencimiento del contrato
                        actual.
                    </Text>
                </Row>
                <Row style={{ marginBottom: 8 }}>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        Si existen errores en el proceso, se descargará automáticamente un Excel con
                        el detalle de cada error.
                    </Text>
                </Row>
                <Row>
                    <div style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}>
                        <Upload {...uploadProps} maxCount={1} accept={FormatoCarga.EXCEL.extension}>
                            <Button style={{ borderRadius: 4, borderColor: "green" }} loading={loading}>
                                <FileExcelOutlined style={{ fontSize: 20, color: "green" }} />{" "}
                                <Text style={{ color: "green" }}>Cargar archivo Excel</Text>
                            </Button>
                        </Upload>
                    </div>
                </Row>
            </div>
        </Modal>
    );
};

export default ModalRenovarMasivamente;
